import React from 'react'
import { StatusCellStyles } from './Style'
import { StatusChip } from '.'

const StatusCell = (props) => {
    const { row } = props

    return (
        <StatusCellStyles>
            <StatusChip {...row.original}/>
        </StatusCellStyles>
    )
}

export default StatusCell